// src/data/educationImages.js

// Old Ansarullah School Classes
import oldSchool1 from '../Images/old-ans/o (1).jpg';
import oldSchool2 from '../Images/old-ans/o (2).jpg';
import oldSchool3 from '../Images/old-ans/o (3).jpg';
import oldSchool4 from '../Images/old-ans/o (4).jpg';
import oldSchool5 from '../Images/old-ans/o (5).jpg';
import oldSchool6 from '../Images/old-ans/o (6).jpg';
import oldSchool7 from '../Images/old-ans/o (7).jpg';
import oldSchool8 from '../Images/old-ans/o (8).jpg';
import oldSchool9 from '../Images/old-ans/o (9).jpg';
import oldSchool10 from '../Images/old-ans/o (10).jpg';
import oldSchool11 from '../Images/old-ans/o (11).jpg';
import oldSchool12 from '../Images/old-ans/o (12).jpg';
import oldSchool13 from '../Images/old-ans/o (13).jpg';
import oldSchool14 from '../Images/old-ans/o (14).jpg';
import oldSchool15 from '../Images/old-ans/o (15).jpg';
import oldSchool16 from '../Images/old-ans/o (16).jpg';
import oldSchool17 from '../Images/old-ans/o (17).jpg';

// // New Ansarullah School Building
import newBuilding1 from '../Images/eftetahya/eft (1).jpg';
import newBuilding2 from '../Images/eftetahya/eft (2).jpg';
import newBuilding3 from '../Images/eftetahya/eft (3).jpg';
import newBuilding4 from '../Images/eftetahya/eft (4).jpg';
import newBuilding5 from '../Images/eftetahya/eft (5).jpg';
import newBuilding6 from '../Images/eftetahya/eft (6).jpg';
import newBuilding7 from '../Images/eftetahya/eft (7).jpg';
import newBuilding8 from '../Images/eftetahya/eft (8).jpg';
import newBuilding9 from '../Images/eftetahya/eft (9).jpg';
import newBuilding10 from '../Images/eftetahya/eft (10).jpg';
import newBuilding11 from '../Images/eftetahya/eft (11).jpg';
import newBuilding12 from '../Images/eftetahya/eft (12).jpg';
import newBuilding13 from '../Images/eftetahya/eft (13).jpg';
import newBuilding14 from '../Images/eftetahya/eft (14).jpg';
import newBuilding15 from '../Images/eftetahya/eft (15).jpg';
import newBuilding16 from '../Images/eftetahya/eft (16).jpg';
import newBuilding17 from '../Images/eftetahya/eft (17).jpg';
import newBuilding18 from '../Images/eftetahya/eft (18).jpg';
import newBuilding19 from '../Images/eftetahya/eft (19).jpg';
import newBuilding20 from '../Images/eftetahya/eft (20).jpg';
import newBuilding21 from '../Images/eftetahya/eft (21).jpg';
import newBuilding22 from '../Images/eftetahya/eft (22).jpg';
import newBuilding23 from '../Images/eftetahya/eft (23).jpg';
import newBuilding24 from '../Images/eftetahya/eft (24).jpg';
import newBuilding25 from '../Images/eftetahya/eft (25).jpg';
import newBuilding26 from '../Images/eftetahya/eft (26).jpg';
import newBuilding27 from '../Images/eftetahya/eft (27).jpg';
import newBuilding28 from '../Images/eftetahya/eft (28).jpg';
import newBuilding29 from '../Images/eftetahya/eft (29).jpg';
import newBuilding30 from '../Images/eftetahya/eft (30).jpg';
import newBuilding31 from '../Images/eftetahya/eft (31).jpg';
import newBuilding32 from '../Images/eftetahya/eft (32).jpg';
import newBuilding33 from '../Images/eftetahya/eft (33).jpg';
import newBuilding34 from '../Images/eftetahya/eft (34).jpg';
import newBuilding35 from '../Images/eftetahya/eft (35).jpg';
import newBuilding36 from '../Images/eftetahya/eft (36).jpg';
import newBuilding37 from '../Images/eftetahya/eft (37).jpg';
import newBuilding38 from '../Images/eftetahya/eft (38).jpg';
import newBuilding39 from '../Images/eftetahya/eft (39).jpg';
import newBuilding40 from '../Images/eftetahya/eft (40).jpg';
import newBuilding41 from '../Images/eftetahya/eft (41).jpg';
import newBuilding42 from '../Images/eftetahya/eft (42).jpg';
import newBuilding43 from '../Images/eftetahya/eft (43).jpg';
import newBuilding44 from '../Images/eftetahya/eft (44).jpg';
import newBuilding45 from '../Images/eftetahya/eft (45).jpg';
import newBuilding46 from '../Images/eftetahya/eft (46).jpg';
import newBuilding47 from '../Images/eftetahya/eft (47).jpg';


// Girls Students
import girls1 from '../Images/Girls/girl (4).jpg';
import girls2 from '../Images/Girls/girl (5).jpg';
import girls3 from '../Images/Girls/girl (3).jpg';
import girls4 from '../Images/Girls/girl (1).jpg';
import girls5 from '../Images/Girls/girl (2).jpg';

// // Boys Students
import boys1 from '../Images/Boys/boys (1).jpg';
import boys2 from '../Images/Boys/boys (6).jpg';
import boys3 from '../Images/Boys/boys (3).jpg';
import boys4 from '../Images/Boys/boys (4).jpg';
import boys5 from '../Images/Boys/boys (5).jpg';
import boys6 from '../Images/Boys/boys (2).jpg';
import boys7 from '../Images/Boys/boys (7).jpg';
import boys8 from '../Images/Boys/boys (8).jpg';
import boys9 from '../Images/Boys/boys (9).jpg';
import boys10 from '../Images/Boys/boys (10).jpg';
import boys11 from '../Images/Boys/boys (11).jpg';
import boys12 from '../Images/Boys/boys (12).jpg';
import boys13 from '../Images/Boys/boys (13).jpg';
import boys14 from '../Images/Boys/boys (14).jpg';
import boys15 from '../Images/Boys/boys (15).jpg';
import boys16 from '../Images/Boys/boys (16).jpg';
import boys17 from '../Images/Boys/boys (17).jpg';
import boys18 from '../Images/Boys/boys (18).jpg';
import boys19 from '../Images/Boys/boys (19).jpg';
import boys20 from '../Images/Boys/boys (20).jpg';
import boys21 from '../Images/Boys/boys (21).jpg';
import boys22 from '../Images/Boys/boys (22).jpg';
import boys23 from '../Images/Boys/boys (23).jpg';
import boys24 from '../Images/Boys/boys (24).jpg';
import boys25 from '../Images/Boys/boys (25).jpg';
import boys26 from '../Images/Boys/boys (26).jpg';
import boys27 from '../Images/Boys/boys (27).jpg';
import boys28 from '../Images/Boys/boys (28).jpg';
import boys29 from '../Images/Boys/boys (29).jpg';
import boys30 from '../Images/Boys/boys (30).jpg';
import boys31 from '../Images/Boys/boys (31).jpg';
import boys32 from '../Images/Boys/boys (32).jpg';
import boys33 from '../Images/Boys/boys (33).jpg';
import boys34 from '../Images/Boys/boys (34).jpg';
import boys35 from '../Images/Boys/boys (35).jpg';
import boys36 from '../Images/Boys/boys (36).jpg';
import boys37 from '../Images/Boys/boys (37).jpg';
import boys38 from '../Images/Boys/boys (38).jpg';
import boys39 from '../Images/Boys/boys (39).jpg';
import boys40 from '../Images/Boys/boys (40).jpg';
import boys41 from '../Images/Boys/boys (41).jpg';
import boys42 from '../Images/Boys/boys (42).jpg';
import boys43 from '../Images/Boys/boys (43).jpg';
import boys44 from '../Images/Boys/boys (44).jpg';


// // Other Activities
// import other1 from '../Images/construction/masjid20.jpg';
// import other2 from '../Images/construction/masjid21.jpg';
// import other3 from '../Images/construction/masjid22.jpg';
// import other4 from '../Images/construction/masjid23.jpg';
// import other5 from '../Images/construction/masjid24.jpg';

export const educationImages = {
  oldSchool: {
    title: 'Ansarullah School ',
    images: [
      { id: 1, src: oldSchool1 },
    { id: 2, src: oldSchool2 },
    { id: 3, src: oldSchool3 },
    { id: 4, src: oldSchool4 },
    { id: 5, src: oldSchool5 },
    { id: 6, src: oldSchool6 },
    { id: 7, src: oldSchool7 },
    { id: 8, src: oldSchool8 },
    { id: 9, src: oldSchool9 },
    { id: 10, src: oldSchool10 },
    { id: 11, src: oldSchool11 },
    { id: 12, src: oldSchool12 },
    { id: 13, src: oldSchool13 },
    { id: 14, src: oldSchool14 },
    { id: 15, src: oldSchool15 },
    { id: 16, src: oldSchool16 },
    { id: 17, src: oldSchool17 },
    ]
  },
  newSchool: {
    title: 'New Ansarullah Opening ceremony',
    images: [
      { id: 1, src: newBuilding1 },
  { id: 2, src: newBuilding2 },
  { id: 3, src: newBuilding3 },
  { id: 4, src: newBuilding4 },
  { id: 5, src: newBuilding5 },
  { id: 6, src: newBuilding6 },
  { id: 7, src: newBuilding7 },
  { id: 8, src: newBuilding8 },
  { id: 9, src: newBuilding9 },
  { id: 10, src: newBuilding10 },
  { id: 11, src: newBuilding11 },
  { id: 12, src: newBuilding12 },
  { id: 13, src: newBuilding13 },
  { id: 14, src: newBuilding14 },
  { id: 15, src: newBuilding15 },
  { id: 16, src: newBuilding16 },
  { id: 17, src: newBuilding17 },
  { id: 18, src: newBuilding18 },
  { id: 19, src: newBuilding19 },
  { id: 20, src: newBuilding20 },
  { id: 21, src: newBuilding21 },
  { id: 22, src: newBuilding22 },
  { id: 23, src: newBuilding23 },
  { id: 24, src: newBuilding24 },
  { id: 25, src: newBuilding25 },
  { id: 26, src: newBuilding26 },
  { id: 27, src: newBuilding27 },
  { id: 28, src: newBuilding28 },
  { id: 29, src: newBuilding29 },
  { id: 30, src: newBuilding30 },
  { id: 31, src: newBuilding31 },
  { id: 32, src: newBuilding32 },
  { id: 33, src: newBuilding33 },
  { id: 34, src: newBuilding34 },
  { id: 35, src: newBuilding35 },
  { id: 36, src: newBuilding36 },
  { id: 37, src: newBuilding37 },
  { id: 38, src: newBuilding38 },
  { id: 39, src: newBuilding39 },
  { id: 40, src: newBuilding40 },
  { id: 41, src: newBuilding41 },
  { id: 42, src: newBuilding42 },
  { id: 43, src: newBuilding43 },
  { id: 44, src: newBuilding44 },
  { id: 45, src: newBuilding45 },
  { id: 46, src: newBuilding46 },
  { id: 47, src: newBuilding47 },
    ]
  },
  girls: {
    title: 'Girls Students',
    images: [
      { id: 1, src: girls1 },
      { id: 2, src: girls2 },
      { id: 3, src: girls3 },
      { id: 4, src: girls4 },
       { id: 5, src: girls5 },
    ]
  },
  boys: {
    title: 'Boys Students',
    images: [
      { id: 1, src: boys1 },
  { id: 2, src: boys2 },
  { id: 3, src: boys3 },
  { id: 4, src: boys4 },
  { id: 5, src: boys5 },
  { id: 6, src: boys6 },
  { id: 7, src: boys7 },
  { id: 8, src: boys8 },
  { id: 9, src: boys9 },
  { id: 10, src: boys10 },
  { id: 11, src: boys11 },
  { id: 12, src: boys12 },
  { id: 13, src: boys13 },
  { id: 14, src: boys14 },
  { id: 15, src: boys15 },
  { id: 16, src: boys16 },
  { id: 17, src: boys17 },
  { id: 18, src: boys18 },
  { id: 19, src: boys19 },
  { id: 20, src: boys20 },
  { id: 21, src: boys21 },
  { id: 22, src: boys22 },
  { id: 23, src: boys23 },
  { id: 24, src: boys24 },
  { id: 25, src: boys25 },
  { id: 26, src: boys26 },
  { id: 27, src: boys27 },
  { id: 28, src: boys28 },
  { id: 29, src: boys29 },
  { id: 30, src: boys30 },
  { id: 31, src: boys31 },
  { id: 32, src: boys32 },
  { id: 33, src: boys33 },
  { id: 34, src: boys34 },
  { id: 35, src: boys35 },
  { id: 36, src: boys36 },
  { id: 37, src: boys37 },
  { id: 38, src: boys38 },
  { id: 39, src: boys39 },
  { id: 40, src: boys40 },
  { id: 41, src: boys41 },
  { id: 42, src: boys42 },
  { id: 43, src: boys43 },
  { id: 44, src: boys44 },
    ]
  },
  other: {
    title: 'Other Activities',
    images: [
    //   { id: 1, src: other1 },
    //   { id: 2, src: other2 },
    //   { id: 3, src: other3 },
    //   { id: 4, src: other4 },
    //   { id: 5, src: other5 },
    ]
  },
  videos: {
    title: 'School Videos',
    videos: [
      // Add your video data here
      //   { id: 1, src: other1 },
    //   { id: 2, src: other2 },
    //   { id: 3, src: other3 },
    ]
  }

};